import { combineReducers } from 'redux';
import dialog from './dialog.reducer';
import message from './message.reducer';
import navbar from './navbar.reducer';
import navigation from './navigation.reducer';
import newFeaturePopperReducer from './new-feature-popper.reducer';
import settings from './settings.reducer';
var baseReducers = combineReducers({
    dialog: dialog,
    message: message,
    navbar: navbar,
    navigation: navigation,
    settings: settings,
    newFeaturePopperReducer: newFeaturePopperReducer
});
export default baseReducers;
